import style from "./Footer.module.scss"
import React from "react";

interface CompanyInfoFooter {
    logo_footer?: string;
    company_name?: string;
    company_name_ru?: string;
    TIN?: bigint,
    OGRNEP?: bigint,
    phone_number?: string,
    email?: string,
    address?: string,
    license?: string,
    licence_url?: string | null,
    person_data_politic?: string
}

interface CompanyInfoFooterProps {
    companyInfo: CompanyInfoFooter;
}

const Footer: React.FC<CompanyInfoFooterProps> = ({companyInfo}) => {
    const year = new Date().getFullYear();
    const politicUrl = companyInfo?.licence_url || '';

    return (
        <div className={style.bgContainer}>
            <div className={style.footer}>
                <div className={style.companyInfoContainer}>
                    <div className={style.firstInfoContainer}>
                        <img id="logoFooter" className={style.logo} src={process.env.REACT_APP_IMAGE_URL + (companyInfo?.logo_footer || '')} alt={"Логотип"}/>
                        <div className={style.companyInfo}>
                            <div>ООО «{companyInfo.company_name_ru}»</div>
                            <div>ИНН: {companyInfo.TIN}</div>
                            <div>ОГРН: {companyInfo.OGRNEP}</div>
                        </div>
                    </div>
                    <div className={style.secondInfoContainer}>
                        <div className={style.title}>Контакты</div>
                        <div className={style.support}>
                            <div className={style.number}>{companyInfo.phone_number}</div>
                            <div className={style.email}>{companyInfo.email}</div>
                        </div>
                        <div className={style.address}>{companyInfo.address}</div>
                    </div>
                    <div className={style.thirdInfoContainer}>
                        <div className={style.license}>{companyInfo.license}</div>
                        <a href={politicUrl}>{companyInfo.person_data_politic}</a>
                        <div className={style.year}>{year} год</div>
                    </div>
                </div>

                <p className={style.companyName}>
                    {companyInfo.company_name}
                </p>
            </div>
        </div>
    )
}

export default Footer;
